import { render, staticRenderFns } from "./PartProgramWS.vue?vue&type=template&id=201937e9&"
import script from "./PartProgramWS.vue?vue&type=script&lang=js&"
export * from "./PartProgramWS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports